import React from 'react';
import classnames from 'classnames';
import styles from './CreateDataProductModal.module.scss';
import { FormControl, Form } from 'react-bootstrap';
import { UseFormRegister } from 'react-hook-form';
import { DataVendor } from 'v2/models';
import FormLabel from 'v2/form/FormLabel/FormLabel';
import { TranslationKeys, PostProcessKeys } from 'translations';
import { useTranslation } from 'react-i18next';

export interface DataProductFormFields {
  name: string;
  description: string;
  data_vendor?: number;
}

interface DataProductFormProps {
  register: UseFormRegister<DataProductFormFields>;
  dataVendor?: DataVendor;
}

const DataProductForm = ({ register, dataVendor }: DataProductFormProps) => {
  const { t } = useTranslation();

  return (
    <div className={classnames(styles.dataProductForm)}>
      <div>
        <FormLabel
          label={`${t(TranslationKeys.dataProduct_one, {
            postProcess: PostProcessKeys.TitleCase,
          })} Name`}
          required={false}
        />
        <div>
          <FormControl
            type="text"
            data-cy="dataset:create-name-field"
            placeholder="Name"
            aria-label="data-product-name-input"
            autoComplete="off"
            maxLength={255}
            {...register('name', { required: true })}
          />
        </div>
      </div>
      <div>
        <FormLabel label={`Description`} required={false} />
        <div>
          <Form.Control
            as="textarea"
            data-cy="dataset:create-description-field"
            rows={3}
            aria-label="data-product-description-input"
            autoComplete="off"
            {...register('description', { required: true })}
          />
        </div>
        {dataVendor && (
          <FormControl
            type="hidden"
            aria-label="data-vendor-hidden-input"
            {...register('data_vendor')}
            value={dataVendor.id}
          />
        )}
      </div>
    </div>
  );
};

export default DataProductForm;
